import * as React from 'react';

import { color, css } from '@coursera/coursera-ui';
import { SvgClose } from '@coursera/coursera-ui/svg';

import type { InformationCardProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import InformationCard from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import InformationCardBody from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCardBody';
import type { TabListProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/TabListCardLayout';
import { TabList } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/TabListCardLayout';
import styles from 'bundles/enterprise-legacy-learner-home/components/InformationCard/styles';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

export type TabListInformationCardProps = InformationCardProps &
  TabListProps & { hasDismissButton?: boolean; onDismiss?: () => void };

const TabListInformationCard = (props: TabListInformationCardProps) => {
  const { children, initialSelectedIndex, trackingName, trackingData, hasDismissButton, onDismiss, ...rest } = props;

  return (
    <InformationCard
      {...rest}
      rootClassName={css(styles.tabListRoot, props.rootClassName).className}
      trackingName={trackingName}
      trackingData={trackingData}
    >
      <InformationCardBody>
        {hasDismissButton && (
          <div {...css(styles.dismissButtonRow)}>
            <button
              type="button"
              {...css(styles.dismissButton)}
              onClick={onDismiss}
              data-e2e="tab-list-information-card-dismiss-button"
            >
              <span {...css(styles.dismissButtonText)}>{_t('Dismiss')}</span>
              <SvgClose color={color.primary} suppressTitle />
            </button>
          </div>
        )}

        <TabList initialSelectedIndex={initialSelectedIndex} trackingName={trackingName} trackingData={trackingData}>
          {children}
        </TabList>
      </InformationCardBody>
    </InformationCard>
  );
};

export default TabListInformationCard;
